import { IconNames } from 'ui/theme';
import { MenuItem, MenuItemVariant } from 'ui/components/Menu';
import { PermissionType } from 'services/permissions';
import { ReportId } from 'services/reports';
import { FeatureAccessKey } from 'types/featureAccess';

export const createActionBarOptions = (
  id: number | null,
  onDeleteClick: () => void,
  onDuplicateClick: () => void,
  onReportClick: (reportId: ReportId) => void,
  featureAccess: Record<FeatureAccessKey, boolean>
): MenuItem[] => {
  const reportSubItems = [
    ...(featureAccess.canAccessSales
      ? [
          {
            label: 'Total Items Sales',
            onOptionClick: () => onReportClick(ReportId.TotalItemSales),
          },
        ]
      : []),
    {
      label: 'Event History',
      onOptionClick: () => onReportClick(ReportId.InventoryEventHistory),
    },
  ];

  const menuItems = [
    {
      icon: IconNames.FBOReportSmall,
      label: 'Show Report',
      disabled: !id || id < 0,
      separateAfter: true,
      subItems: reportSubItems,
    },
    {
      label: 'Duplicate Item',
      onOptionClick: onDuplicateClick,
      icon: IconNames.FBODuplicateSmall,
      permissions: [PermissionType.ItemsCreate],
      dataQa: 'item-three-dot-menu-duplicate-item',
      separateAfter: true,
    },
    {
      label: 'Delete Item',
      onOptionClick: onDeleteClick,
      icon: IconNames.FBODeleteSmall,
      dataQa: 'item-three-dot-menu-delete',
      permissions: [PermissionType.ItemsDelete],
      variant: MenuItemVariant.Danger,
    },
  ];

  return menuItems;
};
